import React, { useState } from 'react'
import $ from 'jquery'
import Validations from './Validations/Validations'
const InputText = (props) => {
    const [value, setValue] = useState()
    const getFieldValue = (event) => {
        if(event.target.value != ""){
            setValue({[event.target.name]: event.target.value})
            props.getAllFieldValues({[event.target.name]: event.target.value})
            $(event.target).closest(".magentoGroup").removeClass("validClass")
        }else{
            $(event.target).closest(".magentoGroup").addClass("validClass")
        }
    }

    return (
        <>
            <input type="text" 
                className="form-control magento_version-field version-field awsNext" 
                name={props.name}
                placeholder={props.label}
                id={props.id}
                onBlur={getFieldValue}
            />
            <Validations setId={props.id} />
        </>
    )
}
export default InputText